/** The unit of a relative date condition — a week starts on Monday. */
export enum PivotRelativeUnitEnum {
  day = 'day',
  week = 'week',
  month = 'month',
  quarter = 'quarter',
  year = 'year',
}
